import styled from 'styled-components'

import { colors } from '../../../../shared/styles/colors'
import { Button } from '@tmov/design-system'

export const ButtonDS = styled(Button).attrs({ size: 'sm' })`
  width: 130px;
  margin: 32px 0 0 auto;
`
export const Container = styled.div`
  display: flex;
  height: 100vh;
  background: ${colors.dashboard};
  flex-direction: column;
`

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
`

export const BreadCrumb = styled.div`
  display: flex;
  width: 100%;
  height: 41px;
  flex-direction: row;
  align-items: center;
  padding: 14px 30px;
  justify-content: space-between;
  background-color: ${colors.dashboard};
  z-index: 97;
`

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.grayDark};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const ContainerCards = styled.div`
  width: 100%;
  height: 100%;
  padding: 36px;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }
`
export const ContainerCenter = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContainerIcons = styled.div`
  display: flex;
  align-items: center;
`

export const HorizontalLine = styled.hr`
  border: 0;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
`
